import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const ContactForm = ({ innerRef }) => {
  const form = useRef();
  const [formData, setFormData] = useState({
    from_name: "",
    user_email: "",
    message: "",
    selected_email: "",
    topic: "",
  });

  const emails = [
    {
      email: "abbonamenti@modellisticaint.it",
      name: "Abbonamenti o arretrati",
    },
    { email: "modellisticaint@modellisticaint.it", name: "Articoli" },
    {
      email: "modellisticaint@modellisticaint.it",
      name: "Pubblicazione locandine eventi",
    },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "selected_email") {
      // Trova l'oggetto corrispondente nell'array emails
      const selectedOption = emails.find((item) => item.email === value);
      setFormData((prevData) => ({
        ...prevData,
        selected_email: value,
        topic: selectedOption ? selectedOption.name : "", // Imposta il topic con il nome associato
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  /*
  const sendEmail = (e) => {
    e.preventDefault();
    if (formData.selected_email) {
      emailjs
        .sendForm("service_vowv3yg", "template_b2t9539", form.current, {
          publicKey: "T66LGOAc1lcMRz2gV",
        })
        .then(
          () => {
            setFormData({
              from_name: "",
              user_email: "",
              message: "",
              selected_email: "",
            });
            console.log("SUCCESS!");
          },
          (error) => {
            console.log("FAILED...", error.text);
          }
        );
    } else {
      console.log("Nessuna email selezionata.");
    }
  };*/

  const sendEmail = (e) => {
    console.log(formData);
    axios
      .post(
        `${API_URL}/contactSupport`,
        {
          supportEmail: formData.selected_email,
          email: formData.user_email,
          name: formData.from_name,
          message: formData.message,
          topic: formData.topic,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        console.log("Email inviata con successo:", response.data);
        window.location.reload();
      })
      .catch((error) => {
        console.error(
          "Errore nell'invio dell'email:",
          error.response ? error.response.data : error.message
        );
      });
  };

  return (
    <div className="min-h-screen" ref={innerRef} name="contactForm">
      {/* Contact Section */}
      <div className="bg-blue-500 mt-8 py-12">
        <div className="max-w-4xl mx-auto text-white text-center">
          <h3 className="text-3xl font-bold mb-4">Hai ancora domande?</h3>
          <p className="text-xl mb-8">
            Compila il nostro modulo o contattaci direttamente tramite le
            informazioni qui sotto.
          </p>
          <div className="flex justify-center space-x-12 mb-8">
            <div>
              {""}
              <p className="text-lg">📞 0584 45286</p>
              <p>Il modo migliore per ottenere una risposta più veloce.</p>
            </div>

            <div>
              <p className="text-lg">✉️ abbonamenti@modellisticaint.it</p>
              <p className="text-lg">✉️ modellisticaint@modellisticaint.it</p>
              <p>Siamo felici di aiutarti!</p>
            </div>
          </div>
        </div>
        {/* Form di contatto */}

        <form
          method="post"
          ref={form}
          onSubmit={(e) => {
            e.preventDefault();
            sendEmail();
          }}
          className="bg-white p-6 rounded-lg shadow-md text-left max-w-2xl
          mx-auto"
        >
          <div className="relative mb-4">
            <label htmlFor="select_email" className="block text-gray-700">
              Seleziona il motivo per cui ci contatti
            </label>
            <select
              id="select_email"
              name="selected_email"
              value={formData.selected_email}
              onChange={handleChange}
              className="block outline-none w-full mt-2 border border-gray-300 rounded-md py-2 px-3 text-gray-700 focus:ring focus:ring-blue-500 focus:border-blue-500 transition"
            >
              <option value="">Seleziona</option>
              {emails.map((item) => (
                <option key={item.name} value={item.email}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-4">
            <label
              className="block text-gray-700 font-bold mb-2"
              htmlFor="name"
            >
              Nome
            </label>
            <input
              type="text"
              id="name"
              name="from_name"
              value={formData.from_name}
              onChange={handleChange}
              className="w-full px-3 py-2 ring-1 ring-gray-300 focus:ring focus:ring-blue-500 transition duration-300 outline-none rounded-md"
              placeholder="Inserisci il tuo nome"
              //required
            />
          </div>
          <div className="mb-4">
            <label
              className="block text-gray-700 font-bold mb-2"
              htmlFor="email"
            >
              Email
            </label>
            <input
              type="email"
              id="user_email"
              name="user_email"
              value={formData.user_email}
              onChange={handleChange}
              className="w-full px-3 py-2 ring-1 ring-gray-300 focus:ring focus:ring-blue-500 transition duration-300 outline-none rounded-md"
              placeholder="Inserisci la tua email"
              //required
            />
          </div>
          <div className="mb-6">
            <label
              className="block text-gray-700 font-bold mb-2"
              htmlFor="message"
            >
              Messaggio
            </label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              className="w-full px-3 py-2 ring-1 ring-gray-300 focus:ring focus:ring-blue-500 transition duration-300 outline-none rounded-md"
              placeholder="Inserisci il tuo messaggio"
              rows="5"
              //required
            />
          </div>
          <div className="text-center">
            <button
              type="submit"
              className="bg-blue-600 text-white px-6 py-3 rounded-lg shadow-md hover:bg-blue-700 transition duration-300"
            >
              Invia Messaggio
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
